const COUNTRIES = [
    {
        taskId: "#VLZ632",
        project: "Velzon - v1.0.0",
        task: "Error message when placing an orders?",
        creater: "Robert McMahon",
        dueDate: "25 Jan, 2022",
        status: "Inprogress",
        statusClass: "secondary",
        priority: "High",
        priorityClass: "danger",
        subItem:'assets/images/users/avatar-5.jpg',
        isSelected:false
    },
    {
        taskId: "#VLZ453",
        project: "Skote - v1.0.0",
        task: "Profile Page Structure",
        creater: "Mary Cousar",
        dueDate: "20 Dec, 2021",
        status: "New",
        statusClass: "info",
        priority: "Low",
        priorityClass: "success",
        subItem:'assets/images/users/avatar-6.jpg',
        isSelected:false
    },
    {
        taskId: "#VLZ454",
        project: "Skote - v2.3.0",
        task: "Apologize for shopping Error!",
        creater: "Nathan Cole",
        dueDate: "23 Oct, 2021",
        status: "Completed",
        statusClass: "success",
        priority: "Medium",
        priorityClass: "warning",
        subItem:'assets/images/users/avatar-4.jpg',
        isSelected:false
    },
    {
        taskId: "#VLZ455",
        project: "Minia - v1.4.0",
        task: "Post launch reminder/ post list",
        creater: "Joseph Parker",
        dueDate: "05 Oct, 2021",
        status: "Pending",
        statusClass: "warning",
        priority: "High",
        priorityClass: "danger",
        subItem:'assets/images/users/avatar-10.jpg',
        isSelected:false
    },
    {
        taskId: "#VLZ456",
        project: "Minia - v1.2.0",
        task: "Make a creating an account profile",
        creater: "Henry Baird",
        dueDate: "17 Oct, 2021",
        status: "Inprogress",
        statusClass: "secondary",
        priority: "Medium",
        priorityClass: "warning",
        subItem:'assets/images/users/avatar-3.jpg',
        isSelected:false
    },
    {
        taskId: "#VLZ657",
        project: "Minimal - v2.1.0",
        task: "Change email option process",
        creater: "Tonya Noble",
        dueDate: "04 Dec, 2021",
        status: "Completed",
        statusClass: "success",
        priority: "High",
        priorityClass: "danger",
        subItem:'assets/images/users/avatar-2.jpg',
        isSelected:false
    },
    {
        taskId: "#VLZ458",
        project: "Dason - v1.1.0",
        task: "User research",
        creater: "Donald Palmer",
        dueDate: "11 Oct, 2021",
        status: "New",
        statusClass: "info",
        priority: "Low",
        priorityClass: "success",
        subItem:'assets/images/users/avatar-10.jpg',
        isSelected:false
    },
    {
        taskId: "#VLZ459",
        project: "Dorsin - Landing Page",
        task: "Benner design for FB & Twitter",
        creater: "Carter",
        dueDate: "16 Dec, 2021",
        status: "Pending",
        statusClass: "warning",
        priority: "Medium",
        priorityClass: "warning",
        subItem:'assets/images/users/avatar-5.jpg',
        isSelected:false
    },
    {
        taskId: "#VLZ460",
        project: "Qexal - Landing Page",
        task: "Brand logo design",
        creater: "David Nichols",
        dueDate: "29 Dec, 2021",
        status: "Pending",
        statusClass: "warning",
        priority: "High",
        priorityClass: "danger",
        subItem:'assets/images/users/avatar-7.jpg',
        isSelected:false
    },
    {
        taskId: "#VLZ461",
        project: "Doot - Chat App Template",
        task: "Additional Calendar",
        creater: "Diana Kohler",
        dueDate: "13 Oct, 2021",
        status: "New",
        statusClass: "info",
        priority: "Low",
        priorityClass: "success",
        subItem:'assets/images/users/avatar-3.jpg',
        isSelected:false
    },
    {
        taskId: "#VLZ462",
        project: "Skote - v2.1.0",
        task: "Edit customer testimonial",
        creater: "Nathan Cole",
        dueDate: "02 Jan, 2021",
        status: "Inprogress",
        statusClass: "secondary",
        priority: "Medium",
        priorityClass: "warning",
        subItem:'assets/images/users/avatar-6.jpg',
        isSelected:false
    },
  ];
  
  const AssignedData = [
      { id: 1, imgId: "anna-adame", img: "avatar-1.jpg", name: "Anna Adame" },
      { id: 2, imgId: "frank-hook", img: "avatar-3.jpg", name: "Frank Hook" },
      { id: 3, imgId: "alexis-clarke", img: "avatar-6.jpg", name: "Alexis Clarke" },
      { id: 4, imgId: "herbert-stokes", img: "avatar-2.jpg", name: "Herbert Stokes" },
      { id: 5, imgId: "michael-morris", img: "avatar-7.jpg", name: "Michael Morris" },
      { id: 6, imgId: "nancy-martino", img: "avatar-5.jpg", name: "Nancy Martino" },
      { id: 7, imgId: "thomas-taylor", img: "avatar-8.jpg", name: "Thomas Taylor" },
      { id: 8, imgId: "tonya-noble", img: "avatar-10.jpg", name: "Tonya Noble" },
    ];
  
  export { COUNTRIES, AssignedData };
  